import React from 'react';
import { Space, Divider, Row, Col, Dropdown } from 'antd';
import { NavLink } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import PropTypes from 'prop-types';
import { CardFrame } from './style';
import Heading from '../../heading/heading';

const Cards = (props) => {
    const {
        title,
        children,
        more,
        moreText,
        size,
        headless,
        caption,
        isbutton,
        bodyStyle,
        headStyle,
        border,
        bodypadding,
        headerActions,
        style,
    } = props;
    return (
        <>
            {!headless ? (
                <CardFrame
                    size={size}
                    bodyStyle={bodyStyle && bodyStyle}
                    headStyle={headStyle && headStyle}
                    bordered={border}
                    bodypadding={bodypadding && bodypadding}
                    title={title}
                    extra={
                        <>
                            {more && (
                                <Dropdown content={more} placement="bottomCenter">
                                    <NavLink to="#">
                                        {!moreText ? <FeatherIcon icon="more-horizontal" /> : 'More'}
                                    </NavLink>
                                </Dropdown>
                            )}
                            {headerActions && headerActions}

                            {isbutton && isbutton}
                        </>
                    }
                    style={{ width: '100%', ...(style || {}) }}
                >
                    {/* <Row
                        style={{
                            padding: '0px 16px',
                        }}
                        align="center"
                        justify={'space-between'}
                    >
                        <Col>{title}</Col>
                        <Col>{headerActions && headerActions}</Col>
                    </Row>
                    <Divider
                        style={{
                            margin: '16px 0',
                            padding: '0',
                        }}
                    /> */}
                    {children}
                </CardFrame>
            ) : (
                <CardFrame
                    bodypadding={bodypadding && bodypadding}
                    bodyStyle={bodyStyle && bodyStyle}
                    size={size}
                    style={{ width: '100%' }}
                    bordered={border}
                >
                    {title && (typeof title === 'string' ? <Heading as="h4">{title}</Heading> : title)}
                    {caption && <p>{caption}</p>}
                    {children}
                </CardFrame>
            )}
        </>
    );
};

Cards.defaultProps = {
    border: false,
};

Cards.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.node]),
    size: PropTypes.string,
    more: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.node]),
    bodyStyle: PropTypes.object,
    headerActions: PropTypes.node,
    headStyle: PropTypes.object,
    isbutton: PropTypes.node,
    headless: PropTypes.bool,
    border: PropTypes.bool,
    caption: PropTypes.string,
    bodypadding: PropTypes.string,
    moreText: PropTypes.bool,
    style: PropTypes.object,
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.node]),
};

export { Cards };
